export { AreasOfFocusSection } from './areas-of-focus-section';
export { BenefitsGrid } from './benefits-grid';
export { CommunityPaymentModel } from './community-payment-model';
export { ComparisonSection } from './comparison-section';
export { CTAWithPreview } from './cta-with-preview';
export { FAQAccordion } from './faq-accordion';
export { FinalCTAWithStats } from './final-cta-with-stats';
export { FinalCTA } from './final-cta';
export { HeroSection } from './hero-section';
export { HeroWithBadge } from './hero-with-badge';
export { HeroWithImages } from './hero-with-images';
export { HowItWorksSimple } from './how-it-works-simple';
export { HowItWorks } from './how-it-works';
export { IconSteps } from './icon-steps';
export { InfoBox } from './info-box';
export { InfoSectionWithVisual } from './info-section-with-visual';
export { ModalitiesSection } from './modalities-section';
export { PricingSection } from './pricing-section';
export { PricingSelector } from './pricing-selector';
export { ProcessSteps } from './process-steps';
export { RedefiningStandards } from './redefining-standards';
export { StatsSection } from './stats-section';
export { TestimonialsSection } from './testimonials-section';
export { TimelineSection } from './timeline-section';
export { UniversityCarousel } from './university-carousel';
export { UniversityPartners } from './university-partners';
export { WhyChooseAlli } from './why-choose-alli';
export { WhyChooseCards } from './why-choose-cards';
export { YourJourney } from './your-journey';

// Export all types
export type { AreaOfFocus, AreasOfFocusSectionProps } from './areas-of-focus-section';
export type { Benefit, BenefitsGridProps } from './benefits-grid';
export type { CommunityPaymentModelProps } from './community-payment-model';
export type { ComparisonItem, ComparisonSectionProps } from './comparison-section';
export type { CTAWithPreviewProps } from './cta-with-preview';
export type { FAQ, FAQAccordionProps } from './faq-accordion';
export type { Stat as FinalCTAStat, FinalCTAWithStatsProps } from './final-cta-with-stats';
export type { FinalCTAProps } from './final-cta';
export type { HeroSectionProps } from './hero-section';
export type { TrustIndicator, HeroWithBadgeProps } from './hero-with-badge';
export type { HeroWithImagesProps } from './hero-with-images';
export type { HowItWorksSimpleProps } from './how-it-works-simple';
export type { Step, HowItWorksProps } from './how-it-works';
export type { IconStep, IconStepsProps } from './icon-steps';
export type { InfoBoxProps } from './info-box';
export type { InfoPoint, InfoSectionWithVisualProps } from './info-section-with-visual';
export type { Modality, ModalitiesSectionProps } from './modalities-section';
export type { PricingTier, PricingSectionProps } from './pricing-section';
export type { PriceRange, PricingSelectorProps } from './pricing-selector';
export type { ProcessStep, ProcessStepsProps } from './process-steps';
export type { Statistic, RedefiningStandardsProps } from './redefining-standards';
export type { Stat, StatsSectionProps } from './stats-section';
export type { TestimonialsProps } from './testimonials-section';
export type { TimelineItem, TimelineSectionProps } from './timeline-section';
export type { UniversityLogo, UniversityCarouselProps } from './university-carousel';
export type { UniversityPartnersProps } from './university-partners';
export type { UniqueFeature, WhyChooseAlliProps } from './why-choose-alli';
export type { WhyChooseCard, WhyChooseCardsProps } from './why-choose-cards';
export type { JourneyStep, YourJourneyProps } from './your-journey';